import { h, render } from "preact";

export default function CompareModalAccordion({ children }) {
  return (
    <custom-details>
      <div className="compare-modal-v2__accordion-content" data-content>
        {children}
      </div>
      <button className="compare-modal-v2__row-accordion-cta" data-summary>
        <span data-opened>Close Details</span>
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-opened
        >
          <path
            d="M18.8337 12.5853V10.752H4.16699V12.5853H18.8337Z"
            fill="black"
          />
        </svg>
        <span data-closed>Open Details</span>
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-closed
        >
          <path
            d="M10.5837 14.8755L12.4377 14.8757V19.001L10.5837 19.0008V14.8755Z"
            fill="black"
          />
          <path
            d="M10.5837 4.33398H12.417V10.7505L18.8337 10.7507V12.5537H4.16699V10.7507H10.5837V4.33398Z"
            fill="black"
          />
        </svg>
      </button>
    </custom-details>
  );
}
